import { I18nComponente } from "@/types/gerais"

export const OCabecalhoPeriodoEntreDatasi18n: I18nComponente = {
  "pt-BR": {
    hoje: "hoje",
    selecionarPeriodo: "selecionar período",
    mes: "mês",
    semana: "semana",
    dia: "dia",
    personalizado: "personalizado",
    todosOsProjetos: "Todos os projetos",
    erroAoBuscarGruposDeProjetos: "Erro ao buscar grupos de projetos",
    requisicaoCancelada: "Requisição cancelada",
    erroAoBuscarProjetos: "Erro ao buscar projetos",
    ocorreuUmErroAoBuscarAsInformacoes: "Ocorreu um erro ao buscar as informações."
  },
  "es-CO": {
    hoje: "hoy",
    selecionarPeriodo: "seleccionar periodo",
    mes: "mes",
    semana: "semana",
    dia: "día",
    personalizado: "personalizado",
    todosOsProjetos: "Todos los proyectos",
    erroAoBuscarGruposDeProjetos: "Error al buscar grupos de proyectos",
    requisicaoCancelada: "Solicitud cancelada",
    erroAoBuscarProjetos: "Error al buscar proyectos",
    ocorreuUmErroAoBuscarAsInformacoes: "Se produjo un error al buscar la información."
  }
}
